'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "defaultPage", "totalPages", "onPageChange"];
import { lazy, Suspense, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var NumericAndDotsPaginator = /*#__PURE__*/lazy(function () {
  return import("./NumericAndDotsPaginator").then(function (module) {
    return {
      "default": module.NumericAndDotsPaginator
    };
  });
});
var ArrowsPaginator = /*#__PURE__*/lazy(function () {
  return import("./ArrowsPaginator").then(function (module) {
    return {
      "default": module.ArrowsPaginator
    };
  });
});
var SliderPaginator = /*#__PURE__*/lazy(function () {
  return import("./SliderPaginator").then(function (module) {
    return {
      "default": module.SliderPaginator
    };
  });
});
var PagesPaginator = /*#__PURE__*/lazy(function () {
  return import("./PagesPaginator").then(function (module) {
    return {
      "default": module.PagesPaginator
    };
  });
});
var BannerPaginator = /*#__PURE__*/lazy(function () {
  return import("./BannerPaginator").then(function (module) {
    return {
      "default": module.BannerPaginator
    };
  });
});
var CarrouselPaginator = /*#__PURE__*/lazy(function () {
  return import("./CarrouselPaginator").then(function (module) {
    return {
      "default": module.CarrouselPaginator
    };
  });
});

// TODO: add banner, carousel and pages variants

export var Paginator = function Paginator(_ref) {
  var currentPage = _ref.currentPage,
    _ref$defaultPage = _ref.defaultPage,
    defaultPage = _ref$defaultPage === void 0 ? 1 : _ref$defaultPage,
    rawTotalPages = _ref.totalPages,
    onPageChange = _ref.onPageChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(currentPage !== null && currentPage !== void 0 ? currentPage : defaultPage),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  if (rawTotalPages <= 0) return null;
  if (currentPage && !onPageChange) console.error('Warning: You must provide an onPageChange function to the Paginator when using the currentPage prop');
  var totalPages = Math.ceil(rawTotalPages);
  var isFirstPage = page === 1;
  var isLastPage = page === totalPages;
  var pageToDisplay = currentPage !== null && currentPage !== void 0 ? currentPage : page;
  var goToPage = function goToPage(newPage) {
    if (pageToDisplay < 1 || pageToDisplay > totalPages) return;
    setPage(newPage);
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(newPage);
  };
  if (otherProps.variant === 'arrows') return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(ArrowsPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
  if (otherProps.variant === 'slider') return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(SliderPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
  if (otherProps.variant === 'pages') return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(PagesPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
  if (otherProps.variant === 'banner') return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(BannerPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
  if (otherProps.variant === 'carrousel') return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CarrouselPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
  return /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(NumericAndDotsPaginator, _objectSpread({
      currentPage: pageToDisplay,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      totalPages: totalPages,
      onPageChange: goToPage
    }, otherProps))
  });
};